import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Message } from '../types/message';

/**
 * service to show success or error messages after user interaktion
 *
 * this service use material snackbar as component
 * @see https://material.angular.io/components/snack-bar/overview
 * @implements {Function} success - shows success message
 * @implements {Function} error - shows error message
 * @param {object} msg
 */
@Injectable({
    providedIn: 'root'
})
export class MessageService {
    #snackBar = inject(MatSnackBar);

    /**
     * show success message
     * message disappears after 5 seconds
     * @param {string} msg - text of message
     * @property {number} duration - default is 5 sec.
     * @property {string} panelClass - default is 'snack-success'
     */
    success(msg: Message) {
        const snackBarRef = this.#snackBar.open(msg.text, msg.action, {
            duration: 5000,
            panelClass: ['snack-success']
        });
        return snackBarRef;
    }

    /**
     * show error message
     * message disappears after 1 minute
     * @param {string} err - text of error message
     * @property {number} duration - default is 1 minute.
     * @property {string} panelClass - default is 'snack-error'
     */
    error(err: Message) {
        const snackBarRef = this.#snackBar.open(err.text, err.action, {
            duration: 60000,
            panelClass: ['snack-error']
        });
        return snackBarRef;
    }
}
